/** Wrapper so string and rich empty states share secondary body styling. */
import { Typography } from '@mui/material';

const TodayEmptyMessageContent = ({ children }) => {
  if (typeof children === 'string') {
    return (
      <Typography variant="body2" color="text.secondary">
        {children}
      </Typography>
    );
  }
  return children;
};

export default TodayEmptyMessageContent;
